module.exports = __webpack_public_path__ + "245d370ef5b371a5e9b8ad6714555800.svg";